import { render, staticRenderFns } from "./PayDetailSection.vue?vue&type=template&id=f3c8e642&scoped=true"
import script from "./PayDetailSection.vue?vue&type=script&lang=js"
export * from "./PayDetailSection.vue?vue&type=script&lang=js"
import style0 from "./PayDetailSection.vue?vue&type=style&index=0&id=f3c8e642&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3c8e642",
  null
  
)

export default component.exports